import React from "react";
import { FileText, Handshake, FileCheck, Wrench, Zap } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "01",
  title: "Primeiro Contato",
  description: "Iniciamos com uma conversa via WhatsApp para entender seus desejos e estilo de viagem preferido.",
  icon: FileText,
  numberClassName: "relative flex flex-col md:flex-row items-start md:items-center transition-all duration-1000 ease-out opacity-100 translate-y-0 !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/retreat_eco_costa_rica.png)]"
}, {
  number: "02",
  title: "Consultoria Exclusiva",
  description: "Nossas especialistas apresentam as melhores opções de destinos, focando em segurança e total conforto.",
  icon: Handshake
}, {
  number: "03",
  title: "Roteiro Personalizado",
  description: "Elaboramos um planejamento detalhado, incluindo hospedagem premium e experiências culturais ricas.",
  icon: FileCheck
}, {
  number: "04",
  title: "Suporte Pré-Viagem",
  description: "Fornecemos todas as orientações, documentos e dicas exclusivas para que você se sinta 100% preparada.",
  icon: Wrench
}, {
  number: "05",
  title: "Embarque e Apoio",
  description: "Você viaja com a segurança de ter nosso suporte especializado à disposição durante toda a jornada.",
  icon: Zap
}];
export default function JornadaDaInstalacao() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return;
}
function TimelineItem({
  step,
  index
}: {
  step: typeof steps[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const isEven = index % 2 === 0;
  const isFirst = index === 0;
  return <div ref={ref} data-index={index} className={cn("relative flex flex-col md:flex-row items-start md:items-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16")}>
      {}
      <div className="absolute left-8 -translate-x-1/2 md:hidden flex items-center justify-center size-10 rounded-full bg-chart-2 border-4 border-background z-10 shadow-lg">
        <step.icon className="text-white size-5" />
      </div>

      {}
      <div className={cn("hidden md:block flex-1", isEven && !isFirst ? "order-1" : "order-3")} />

      {}
      

      {}
      <div className={cn("w-full md:w-[calc(50%-3rem)] pl-20 md:pl-0 flex-1", isFirst ? "md:text-left md:pl-12 order-1" : isEven ? "md:text-left md:pr-12 order-3" : "md:text-right md:pl-12 order-1")}>
        
      </div>
    </div>;
}